// routes.tsx
import React from 'react';
import CourseDetails from '../pages/program/CourseDetails';
import CourseProgress from '../pages/program/CourseProgress';
import Program from '../pages/program/Course';
import SubjectList from '../pages/admin/course/SubjectList';
import CourseList from '../pages/admin/course/CourseList';
import ChapterList from '../pages/admin/course/ChapterList';
import EpicList from '../pages/admin/course/EpicList';
import LessonList from '../pages/admin/course/LessonList';
import TranslateList from '../pages/admin/course/TranslateList';
import LessonBlocklyGame from '../pages/admin/course/lessonBlocklyGame/LessonBlocklyGame';
import LessonBlocklyDraw from '../pages/admin/course/lessonBlocklyDraw/LessonBlocklyDraw';
import UserAppList from '../pages/admin/user/UserAppList';
import PasswordList from '../pages/admin/user/PasswordList';
import BlocklyObjects from '../pages/admin/blocklyObjects/BlocklyObjects';
import AffectedUsersList from '../pages/configuration/users/AffectedUsersList';
import UserForm from '../pages/configuration/users/userForm/UserForm';
import RoleTypeUser from '../pages/admin/roles/RoleTypeUser';
import AccessDenied from '../pages/auth/accessDenied/AccessDenied';
import AuthRedirect from './AuthRedirect';
import routeConfigs from './routeConfig';
import Login from '../pages/auth/auth/Login';
import Register from '../pages/auth/auth/Register';
import SignupWizard from '../pages/auth/signup/SignupWizard';
import SetPassword from '../pages/auth/signup/SetPassword';
import SignupFunnelDashboard from '../pages/admin/signup/SignupFunnelDashboard';
import EmailConfirm from '../pages/auth/callback/EmailConfirm';
import ResetPassword from '../pages/auth/auth/ResetPassword';
import LessonBlocklyArcade from '../pages/admin/course/lessonBlocklyArcade/LessonBlocklyArcade';
// import ResearchandDevelopment from '../pages/r&d/ResearchandDevelopment';
import LessonSlide from '../pages/admin/course/lessonSlide/LessonSlide';
import LessonForms from '../pages/admin/course/lessonForms/LessonForms';
import Dashboard from '../pages/dashboard/Dashboard';
import ResearchandDevelopment from '../pages/r&d/ResearchandDevelopment';
import { SpriteEditor } from '../pages/admin/sprites/SpriteEditor';
import SpriteList from '../pages/admin/sprites/SpriteList';
import LessonBlocklyPhaserAdmin from '../pages/admin/course/BlocklyPhaser/LessonBlocklyPhaser';
import LessonIDEPhaser from '../pages/admin/course/IDEPhaser/LessonIDEPhaser';
import LessonHtmlCss from '../pages/admin/course/HtmlCss/LessonHtmlCss';
import LessonIDEConsole from '../pages/admin/course/IDEConsole/LessonIDEConsole';

import AnnonceList from '../pages/admin/advert/AnnonceList';
import Media from '../pages/admin/media/Media';
import LessonProjectList from '../components/Project/lesson_project';
import CreationDetails from '../pages/project/CreationDetails';
import WorkflowList from '../pages/admin/workflow/WorkflowList';
import WorkflowStepsList from '../pages/admin/workflow/WorkflowStepsList';
import ListStudent from '../pages/project/student/ProjectList';
import Projects from '../pages/project/list/List';
import OrganisationStore from '../pages/project/store/OrganisationStore';
import TilmiStore from '../pages/project/store/TilmiStore';
import LessonH5P from '../pages/admin/course/lessonH5P/LessonH5P';
import LessonAIDataset from '../pages/admin/course/lessonAIDataset/LessonAIDataset';
import LessonAIModelBuilder from '../pages/admin/course/lessonAIModelBuilder/LessonAIModelBuilder';
import LessonAIPlayGround from '../pages/admin/course/lessonAIPlayGround/LessonAIPlayGround';
import LessonAILessonPrompting from '../pages/admin/course/lessonAILessonPrompting/LessonAILessonPrompting';
import LessonPuzzle from '../pages/admin/course/lessonPuzzle/LessonPuzzle';
import LessonAssociation from '../pages/admin/course/lessonAssociation/LessonAssociation';
import LessonGraphicDesign from '../pages/admin/course/lessonGraphicDesign/LessonGraphicDesign';
import Paiement from '../pages/paiement/Paiement';
import RetourPaiement from '../pages/paiement/RetourPaiement';
import Pricing from '../pages/paiement/Pricing';
import PricingB2B from '../pages/paiement/PricingB2B';
import MonitoringStudents from '../pages/monitoring/MonitoringStudents';
import MonitoringFinance from '../pages/monitoring/MonitoringFinance';
import MonitoringAiPrices from '../pages/monitoring/MonitoringAiPrices';
import EspaceApporteur from '../pages/apporteur/EspaceApporteur';
import ApporteursAdmin from '../pages/admin/apporteurs/ApporteursAdmin';


const routeComponents: { [key: string]: React.ReactElement } = {
  '/': <AuthRedirect />,
  '/login': <Login />,
  // Tunnel parent (freemium / premium). Le formulaire complet historique reste
  // accessible aux écoles, qui ont besoin des champs organisation.
  '/register': <SignupWizard />,
  '/register-organisation': <Register />,
  '/set-password': <SetPassword />,
  '/callback/email-confirm': <EmailConfirm />,
  '/reset-password': <ResetPassword />,
  '/dashboard': <Dashboard />,
  // La liste des parcours a ete supprimee : /program affiche directement les cours,
  // le parcours devenant un tag + un filtre sur la liste.
  '/program': <Program />,
  '/projects': <ListStudent />,
  '/project-details/:projectId': <CreationDetails />,
  '/subject-courses/:subjectId': <Program />,
  '/course-details/:courseId': <CourseDetails />,
  '/course-progression/:lessonId': <CourseProgress />,

  '/conf/users': <AffectedUsersList />,
  '/conf/users/form': <UserForm />,
  
  '/paiement': <Paiement />,
  // Retour du prestataire apres un paiement par carte. L'activation vient du
  // webhook, pas de cette redirection : l'ecran constate, il n'active rien.
  '/paiement/retour': <RetourPaiement />,
  '/paiement/pricing': <Pricing />,
  '/paiement/pricing-b2b': <PricingB2B />,

  '/monitoring/students': <MonitoringStudents />,
  '/monitoring/finance': <MonitoringFinance />,
  '/monitoring/ai-prices': <MonitoringAiPrices />,

  '/apporteur': <EspaceApporteur />,
  '/setup/apporteurs': <ApporteursAdmin />,

  '/setup/subject': <SubjectList />,
  '/setup/course': <CourseList />,
  '/setup/chapter': <ChapterList />,
  '/setup/epic': <EpicList />,
  '/setup/lesson': <LessonList />,
  '/setup/translations': <TranslateList />,
  '/setup/lesson-blockly-phaser': <LessonBlocklyPhaserAdmin />,
  '/setup/lesson-blockly-game': <LessonBlocklyGame />,
  '/setup/lesson-blockly-draw': <LessonBlocklyDraw />,
  '/setup/lesson-blockly-arcade': <LessonBlocklyArcade />,
  '/setup/lesson-slide': <LessonSlide />,
  '/setup/lesson-forms': <LessonForms />,
  '/setup/lesson-pscode': <LessonIDEPhaser language='javascript' />,
  '/setup/lesson-htmlcss': <LessonHtmlCss />,
  '/setup/lesson-pythonphaser': <LessonIDEPhaser language='python' />,
  '/setup/lesson-console-js': <LessonIDEConsole language='javascript' />,
  '/setup/lesson-console-py': <LessonIDEConsole language='python' />,
  '/setup/lesson-h5p': <LessonH5P />,
  '/setup/lesson-ai-dataset': <LessonAIDataset />,
  '/setup/lesson-ai-model-builder': <LessonAIModelBuilder />,
  '/setup/lesson-ai-play-ground': <LessonAIPlayGround />,
  '/setup/lesson-ai-prompting': <LessonAILessonPrompting />,
  '/setup/lesson-puzzle': <LessonPuzzle />,
  '/setup/lesson-association': <LessonAssociation />,
  '/setup/lesson-graphic-design': <LessonGraphicDesign />,
  '/setup/signup-funnel': <SignupFunnelDashboard />,
  '/setup/users': <UserAppList />,
  '/setup/passwords': <PasswordList />,
  '/setup/blockly-objects': <BlocklyObjects />,
  '/setup/media': <Media />,
  '/setup/sprites': <SpriteList />,
  '/setup/sprites/edit': <SpriteEditor />,
  '/setup/roles': <RoleTypeUser />,
  '/setup/advert': <AnnonceList />,
  '/workflows': <WorkflowList />,
  '/workflow-steps': <WorkflowStepsList />,
  '/rd': <ResearchandDevelopment />,
  '/setup/lesson_project': <LessonProjectList />,
  '/student-projects': <Projects />,
  '/student-projects-store': <OrganisationStore />,
  '/student-projects-tilmistore': <TilmiStore />,
  '/access-denied': <AccessDenied />,
};

const routes = routeConfigs.map(route => {
  const element = routeComponents[route.path];
  return {
    ...route,
    element,
  };
});

export default routes;
